import * as types from '../actionTypes/AddToCartInterstitialActionTypes';

const CarePlanWarrantyReducer = function CarePlanWarrantyReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case types.CARE_PLAN_WARRANTY_RESPONSE:
            return { ...state, warrantyContent: action.response, receivedApiResponse: true };
        case types.CARE_PLAN_WARRANTY_SET_API_STATUS:
            return { ...state, receivedApiResponse: action.status };
        default:
            return state;
    }
};

CarePlanWarrantyReducer.reducerName = 'carePlanWarrantyReducer';

export default CarePlanWarrantyReducer;
